import { SageApiError } from "../utils/sageApiError"
import { parseSageCostCode } from "../utils/sageCodes"
import { parseJobCodeList } from "../utils/jobCodeList"
import { SpreadsheetImportResult } from "../utils/spreadsheetImportResult"
import { sageJobSiteService } from "./sageJobSiteService"

export const INVALID_JOB_CODE_REASON = "invalid-code"

export async function importPlainJobCodeList(options: {
  companyId: number
  jobSiteId: number
  text: string
}): Promise<SpreadsheetImportResult> {
  const rows = parseJobCodeList(options.text)
  const result: SpreadsheetImportResult = { imported: 0, skipped: 0, failures: [] }

  for (const row of rows) {
    const parsed = parseSageCostCode(row.code)
    if (parsed == null) {
      result.failures.push({
        row: row.line,
        code: row.code,
        message: INVALID_JOB_CODE_REASON,
      })
      continue
    }
    try {
      await sageJobSiteService.createCostCode(options.companyId, {
        jobSiteId: options.jobSiteId,
        code: parsed,
        name: row.name,
      })
      result.imported += 1
    } catch (error) {
      result.failures.push({
        row: row.line,
        code: row.code,
        message: error instanceof SageApiError && error.message
          ? error.message
          : "failed",
      })
    }
  }

  return result
}
